import type { InputHTMLAttributes, ReactNode } from 'react'
import { classes } from 'src/utils'

type Props = {
  children: ReactNode
  onSubmit?: InputHTMLAttributes<HTMLFormElement>['onSubmit']
  className?: string
}

export function Form(props: Props) {
  return (
    <form
      onSubmit={props.onSubmit}
      className={classes(
        'grid items-center grid-cols-2 gap-6',
        props.className,
      )}
    >
      {props.children}
    </form>
  )
}
